import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import WidgetWrapper from './WidgetWrapper';
import { Box, Button, Divider, FormControlLabel , Typography, useTheme, Grid, Paper, useMediaQuery } from "@mui/material";


const data1 = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export function parseString(value, length) {
  let str = value
  const arr = []
  while (str.length > 0) {
    const tmpStr = str.slice(0, length)
    const sliced = str.slice(length)
    arr.push(tmpStr)
    if (sliced.length < length) {
      arr.push(sliced)
      str = ""
    } else {
      str = sliced
    }
  }
  return arr.filter(Boolean)
}

const StackedBarChart = ({data}) => {

       const theme = useTheme();  

   const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props
  const labels = parseString(payload.value, 13)
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={16} fill="#666" textAnchor="middle">
        {labels.map((item, i) => (
          <tspan key={i} x="0" dy={`${i === 0 ? 0 : 1.2}em`}>
            {item}
          </tspan>
        ))}
      </text>
    </g>
  )
}

var tooltip
const CustomTooltip = ({ active, payload }) => {
    if (!active || !tooltip)    return null
    // for (const bar of payload)
        // if (bar.dataKey === tooltip)
        //     return <div>{ bar.name }<br/>{ bar.value.toFixed(2) }</div>

    // return null
    console.log(payload);
    return (
      <Box 
       sx={{
        backgroundColor: "#E0E0E0",
        p:'0.5em',
        border: 'solid 2px black',
        // width: '15em', 
        // justifyItems:'center'
       }}>
        <Typography variant='h3' sx={{ color: 'black' }}>{payload[0].payload.name}</Typography>
        <Divider size="large"/>
        <table>
          <tr>
            <td><Typography sx={{ color: `${payload[0]?.color}`, justifyContent: 'space-between', display: 'inline-block' }}>{payload[0].name}: </Typography></td>
            <td><Typography sx={{ ml:'1em', color: `${payload[0]?.color}`, justifyContent: 'space-between', display: 'inline-block' }}>{(100*(payload[0].value)).toFixed(2)}%</Typography></td>
          </tr>
          <tr>
            <td><Typography sx={{ color: `${payload[1].color}`, justifySelf: 'center', display: 'inline-block' }}>{payload[1].name}: </Typography></td>
            <td><Typography sx={{ ml:'1em', color: `${payload[1].color}`, justifySelf: 'center', display: 'inline-block' }}>{(100*(payload[1].value)).toFixed(2)}%</Typography></td>
          </tr>
          <tr>
            <td><Typography sx={{ color: `${payload[2]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{payload[2].name}: </Typography></td>
            <td><Typography sx={{ ml:'1em', color: `${payload[2]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{(100*(payload[2].value)).toFixed(2)}%</Typography></td>
          </tr>
          <tr>
            <td><Typography sx={{ color: `${payload[3]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{payload[3].name}: </Typography></td>
            <td><Typography sx={{ ml:'1em', color: `${payload[3]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{(100*(payload[3].value)).toFixed(2)}%</Typography></td>
          </tr>
          
          <tr>
            <td><Typography sx={{ color: `${payload[4]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{payload[4].name}: </Typography></td>
            <td><Typography sx={{ ml:'1em', color: `${payload[4]?.color}`, justifySelf: 'center', display: 'inline-block' }}>{(100*(payload[4].value)).toFixed(2)}%</Typography></td>
          </tr>
        </table>        
      </Box>
    )
}


  return (
    <div style={{ width: '100%', height: 400 }}>
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={375}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name"
        height={50}
         tick={<CustomizedAxisTick />}
          tickFormatter={(value) => value.length > 10 ? `${value.slice(0, 10)}...` : value} />
        <YAxis />
        <Tooltip
  //         labelFormatter={(value, props ) => {
  //           console.log(value);
  //           console.log(props);
  //           return (
  //            <div>{value}</div>
  //           )
  // }} 
  
  // labelFormatter={value => {
  //   return `label: ${value}`;
  // }} 
  // shared={false}

  content={<CustomTooltip/>}
        />
        <Legend />
        <Bar dataKey="Traditional" stackId="a" fill="#062661ff" onMouseOver={ () => tooltip="Traditional"} />
        <Bar dataKey="Initial" stackId="a" fill="#62aff8ff" onMouseOver={ () => tooltip="Initial"} />
        <Bar dataKey="Advanced" stackId="a" fill="#3b6097ff" onMouseOver={ () => tooltip="Advanced"} />
        <Bar dataKey="Optimal" stackId="a" fill="#7b95b6ff" onMouseOver={ () => tooltip="Optimal"} />
        <Bar dataKey="None" stackId="a" fill="#bb3e3eff" onMouseOver={ () => tooltip="None"} />
      </BarChart>
    </ResponsiveContainer>
    </div>
  );
};

export default StackedBarChart;
